export default __webpack_public_path__ + "static/media/c.4a0b209e.jpg";